import styles from './card.module.scss';
import MaterialCard from '@mui/material/Card';
import MaterialCardHeader from '@mui/material/CardHeader';
import MaterialCardContent from '@mui/material/CardContent';
import MaterialCardActions from '@mui/material/CardActions';
import MaterialCardActionArea from '@mui/material/CardActionArea';
import MaterialCardMedia from '@mui/material/CardMedia';
import { ReactNode } from 'react';

/* eslint-disable-next-line */
export interface CardProps {
  children: any,
  // classes?: object,
  raised?: boolean,
  sx?: any,
  className?: string,
  variant?: 'elevation' | 'outlined',
  ['data-testid']?: string
}

export interface CardHeaderProps {
  action?: ReactNode,
  avatar?: ReactNode,
  // classes?: object,
  // component?: any,
  // disableTypography?: boolean,
  subheader?: ReactNode,
  // subheaderTypographyProps?: object,
  // sx?: any,
  title?: ReactNode,
  titleTypographyProps?: object
  sx?: any,
  ['data-testid']?: string
}

export interface CardContentProps {
  children: any,
  // classes?: object,
  // component?: any,
  sx?: any
  className?: string,
  ['data-testid']?: string
}

export interface CardActionsProps {
  children: any,
  // classes?: object,
  // disableSpacing?: boolean,
  sx?: any,
  className?: string
}

export interface CardActionAreaProps {
  children: any,
  // classes?: object,
  sx?: any
}

export interface CardMediaProps {
  children?: any,
  // classes?: object,
  component?: any,
  image?: string,
  src?: string,
  sx?: any
}

export function Card(props: CardProps) {
  return (
    <MaterialCard
      className={props.className}
      variant={props.variant}
      sx={props.sx}
      raised={props.raised}
      data-testid={props['data-testid']}>
      {props.children}
    </MaterialCard>
  );
}

export function CardHeader(props: CardHeaderProps) {
  return (
    <MaterialCardHeader
      title={props.title}
      subheader={props.subheader}
      avatar={props.avatar}
      action={props.action}
      sx={props.sx}
      titleTypographyProps={props.titleTypographyProps}
      data-testid={props['data-testid']}>
    </MaterialCardHeader>
  );
}

export function CardContent(props: CardContentProps) {
  return (
    <MaterialCardContent
      className={props.className}
      sx={props.sx}
      data-testid={props['data-testid']}>
      {props.children}
    </MaterialCardContent>
  );
}

export function CardActions(props: CardActionsProps) {
  return (
    <MaterialCardActions
      className={props.className}
      sx={props.sx}>
      {props.children}
    </MaterialCardActions>
  );
}

export function CardActionArea(props: CardActionAreaProps) {
  return (
    <MaterialCardActionArea
      sx={props.sx}>
      {props.children}
    </MaterialCardActionArea>
  );
}

export function CardMedia(props: CardMediaProps) {
  return (
    <MaterialCardMedia
      component={props.component}
      image={props.image}
      src={props.src}
      sx={props.sx}>
      {props.children}
    </MaterialCardMedia>
  );
}

export default Card;